import pick from 'lodash/pick';
import React from 'react';
import Tag from 'core/components/Tag';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  BulkPaperClaimsDTO,
} from 'dtos';
import {
  formatDateTime,
} from 'utils/date';
import FileDownloadButton, {
  keysForFileDownload,
} from 'pages/Dashboard/components/FileDownloadButton';
import Name from 'pages/Dashboard/components/Name';
import {
  readableReportState,
  ReportState,
} from 'pages/Dashboard/pages/Reports/columns';

export default [{
  id: 'reportState',
  accessorKey: 'reportState',
  columnTitle: 'Status',
  minSize: 100,
  meta: { autoSized: true },
  cell: ({ row }) => (
    <Tag tagName={row.original?.reportState ?? '--'}>
      {readableReportState[row.original.reportState as ReportState]}
    </Tag>
  ),
}, {
  id: 'createdAt',
  accessorKey: 'createdAt',
  columnTitle: 'Created on',
  size: 80,
  cell: ({ row: { original: { createdOn } } }) => (
    formatDateTime(createdOn ?? '')
  ),
}, {
  id: 'createdBy',
  accessorKey: 'createdBy',
  columnTitle: 'Created by',
  size: 220,
  cell: ({ row: { original: { requestedByUser } } }) => (
    <Name
      {...requestedByUser?.formattedNames}
      image
    />
  ),
}, {
  id: 'bulkPaperClaimsId',
  accessorKey: 'bulkPaperClaimsId',
  columnTitle: '',
  size: 40,
  cell: ({ row: { original } }) => (
    <FileDownloadButton
      type="bulk paper claims"
      id={original?.bulkPaperClaimsId ?? 0}
      {...pick(original, keysForFileDownload)}
    />
  ),
}] as ColumnDef<BulkPaperClaimsDTO>[];
